var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChatsCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.66401 10.9923C1.96351 9.81208 1.71797 8.41675 1.97353 7.06833C2.22908 5.71992 2.96813 4.51119 4.05189 3.66915C5.13564 2.82712 6.48952 2.40973 7.85927 2.49536C9.22902 2.58098 10.5204 3.16375 11.4908 4.13419C12.4613 5.10464 13.044 6.396 13.1297 7.76575C13.2153 9.1355 12.7979 10.4894 11.9559 11.5731C11.1138 12.6569 9.9051 13.3959 8.55669 13.6515C7.20827 13.907 5.81294 13.6615 4.63276 12.961L2.68745 13.5157C2.6073 13.5382 2.52259 13.539 2.44204 13.518C2.36148 13.4969 2.28799 13.4548 2.22912 13.3959C2.17025 13.337 2.12812 13.2635 2.10706 13.183C2.08601 13.1024 2.08679 13.0177 2.10932 12.9376L2.66401 10.9923Z",
    stroke: "#1A181E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.19531 13.7422C7.47066 14.5272 7.91694 15.2413 8.50192 15.8328C9.0869 16.4244 9.79597 16.8786 10.5779 17.1626C11.3598 17.4467 12.1951 17.5535 13.0233 17.4754C13.8516 17.3973 14.6522 17.1362 15.3672 16.7109V16.7109L17.3125 17.2656C17.3927 17.2882 17.4774 17.2889 17.5579 17.2679C17.6385 17.2468 17.712 17.2047 17.7708 17.1458C17.8297 17.087 17.8718 17.0135 17.8929 16.9329C17.9139 16.8524 17.9132 16.7677 17.8906 16.6875L17.3359 14.7422C17.8311 13.9109 18.1032 12.9659 18.1259 11.9986C18.1485 11.0313 17.9208 10.0745 17.465 9.22105C17.0092 8.36758 16.3407 7.64631 15.5242 7.12715C14.7077 6.60799 13.7709 6.30854 12.8047 6.25781",
    stroke: "#1A181E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatsCircle);
export default __webpack_public_path__ + "static/media/chats-circle.785c24671ca3d842126220fb31b4c5e4.svg";
export { ForwardRef as ReactComponent };